import { Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import TextExpressionInput from 'components/inputs/text-expression/TextExpressionInput';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import {
  IFormInputContext,
  IFormInputSpec,
  IFormInputSpecTextExpression,
} from 'pages/revisions-module/template-editor/editors/form/types';
import { useMemo } from 'react';

interface TextExpressionInputPropertiesSubFormProps {
  form: UseFormReturnType<IFormInputSpec>;
  context: IFormInputContext;
}

/**
 * Sub-form for the text expression input type.
 * Lets the user compose a template string from constant text and
 * references to other fields in the same context.
 */
export default function TextExpressionInputPropertiesSubForm({
  form,
  context,
}: TextExpressionInputPropertiesSubFormProps) {
  const { allInputs } = useFormInputs();

  /** Fields available for referencing — same context, excluding this field itself. */
  const items = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === context && input.spec.name !== form.values.name)
        .map(({ spec }) => ({ id: spec.name, label: spec.label })),
    [allInputs, context, form.values.name]
  );

  const spec = form.values as IFormInputSpecTextExpression;

  return (
    <Stack spacing={12}>
      <TextExpressionInput
        label="Výraz"
        required
        items={items}
        value={spec.template ?? ''}
        onChange={(value) => form.setFieldValue('template', value)}
      />
    </Stack>
  );
}
